import { render, staticRenderFns } from "./LabSend.vue?vue&type=template&id=2e794c7e"
import script from "./LabSend.vue?vue&type=script&lang=js"
export * from "./LabSend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports